import React from 'react';
import SingleButton from "../../../../component/button/SingleButton";
import Loading from "../../../../component/loading/Loading";
import Modal from "../../../../component/modal/ModalTemplate";

class UpdateImageSuccessModal extends React.Component {
    constructor(props){
        super(props);

        this.setLoading = this.setLoading.bind(this);

        this.state = {
            loading: false,
        }
    }//end constructor

    setLoading(loading) {
        this.setState({ loading: loading });
    }


    render() {
        const { loading } = this.state;
        const { isClose, open } = this.props;

        return (
            <Modal
                className={"react-modal"}
                open={open}
                handleClose={isClose}
                overlayClassName="modal-overlay"
            >
                <Loading loading={loading}/>
                <div className='modal-body'>
                    이미지 수정이 완료되었습니다.<br/>
                </div>
                <div className='modal-footer'>
                    <SingleButton
                        className='btn btn-primary btn-md'
                        handleClick={isClose}
                        label='확인'
                    />
                </div>
            </Modal>
        )
    }// end render
}// end class

export default UpdateImageSuccessModal;
